module.exports = __webpack_public_path__ + "img/motor_no23.bb329926.jpg";